<template>
  <div>
    <el-button class="create-btn" type="primary" @click="createPosition"
      >新增岗位</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="role_id" label="岗位 ID"></el-table-column>
      <el-table-column prop="role_name" label="岗位名称"></el-table-column>
      <el-table-column prop="content" label="岗位描述"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editPosition(scope.row.role_id)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { postRoleList } from "@/openapi/erp/baobanRoles.js";
export default {
  name: "Positions",
  data() {
    return {
      tableData: [
        // Add your data here
      ],
    };
  },
  created() {
    // postRoleList
    this.fetchData();
  },
  methods: {
    // fetch postRoleList api
    fetchData() {
      postRoleList().then((res) => {
        console.log("🚀 : postRoleList : res:", res);
        this.tableData = res.list;
      });
    },
    createPosition() {
      this.$router.push({ path: "/home/position-permission/positions/create" });
    },
    editPosition(id) {
      this.$router.push(`/home/position-permission/positions/edit/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.create-btn {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/positionPermissions/Positions.vue